module.exports = __webpack_public_path__ + "img/next.7a856249.png";